import { TFunction } from "i18next";

export const getHelperTextForAddress = (isElectricity: boolean, isR1Process: boolean, t: TFunction<"hints">) => {
  if (isElectricity) {
    if (isR1Process) {
      return t("supplyPoint.addressesSupplyPointEleR1");
    }
    return t("supplyPoint.addressesSupplyPointEle");
  } else {
    if (isR1Process) {
      return t("supplyPoint.addressesSupplyPointGasR1");
    }
    return t("supplyPoint.addressesSupplyPointGas");
  }
};
